/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h2[_ngcontent-%COMP%]{margin-bottom:25px;text-align:center}[_nghost-%COMP%]     .btn{width:100%}.forgot-password-form[_ngcontent-%COMP%]{margin-top:20px}.fp-description[_ngcontent-%COMP%]{font-size:11px;text-align:center}"];
export { styles as styles };
